import { SvgIcon, SvgIconProps } from '@mui/material';

const CheckMark = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 24, height: 24, fill: 'none' }}
      data-testid="checkIcon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#D2FCE1"
      />
      <path
        d="M6.17409 12.4011C5.94197 12.6417 5.94197 13.0218 6.17409 13.2624L10.3136 17.5523C10.375 17.6159 10.4772 17.6159 10.5386 17.5523L17.8259 10.0002C18.058 9.75964 18.058 9.3795 17.8259 9.13894L16.9111 8.19089C16.6655 7.93637 16.2566 7.93637 16.011 8.19089L10.5386 13.8621C10.4772 13.9257 10.375 13.9257 10.3136 13.8621L7.989 11.4531C7.7434 11.1985 7.3345 11.1985 7.0889 11.4531L6.17409 12.4011Z"
        fill="#25AE6C"
      />
    </SvgIcon>
  );
};

export default CheckMark;
